import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableSelectBox({size, viewSelectedFunction, clearSelectedFunction, selectAllFunction, deselectAllFunction}) {

    let viewSelected = null;
    let clearSelected = null;
    let selectAll = null;
    let deselectAll = null;

    if (viewSelectedFunction) {
        viewSelected = (
            <div onClick={viewSelectedFunction} >
                <FormattedMessage id="General_CoreFunctionality_UIText_tableSelectBox.viewSelected" />
            </div>
        )
    }

    if (clearSelectedFunction) {
        clearSelected = (
            <div onClick={clearSelectedFunction} >
                <FormattedMessage id="General_CoreFunctionality_UIText_tableSelectBox.clear" />
            </div>
        )
    }

    if (selectAllFunction) {
        selectAll = (
            <div onClick={selectAllFunction} >
                <FormattedMessage id="General_CoreFunctionality_UIText_tableSelectBox.selectAll" />
            </div>
        )
    }

    if (deselectAllFunction) {
        deselectAll = (
            <div onClick={deselectAllFunction} >
                <FormattedMessage id="General_CoreFunctionality_UIText_tableSelectBox.deselectAll" />
            </div>
        )
    }

    if (size == 0 || size == null) {
        viewSelected = null;
        clearSelected = null;
    }

    let dropContent = null;

    if (!viewSelected && !clearSelected && !selectAll && !deselectAll) {
        dropContent = (
            <div className="dropdown-content">
                <div onClick={clearSelectedFunction} >
                    <FormattedMessage id="General_CoreFunctionality_UIText_tableSelectBox.viewAll" />
                </div>
            </div>
        );
    } else {
        dropContent = (
            <div className="dropdown-content">
                {viewSelected}
                {clearSelected}
                {selectAll}
                {deselectAll}
            </div>
        );
    }

    return (
        <span className="tableSelectBox">
            <label className="la-TriangleDown">
                <span>{size}</span>
                {dropContent}
            </label>
        </span>
    );

}

export default TableSelectBox;


// WEBPACK FOOTER //
// ./src/scripts/reusable/TableSelectBox/TableSelectBox.index.jsx